export function Controldate(eventDate) {
    const eventDateObj = new Date(eventDate);
    const currentDate = new Date();
    const isPastEvent = eventDateObj < currentDate;
    return isPastEvent;
};

